import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import MDSelect from "components/MDSelect";

import PieChart from "examples/Charts/PieChart";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

import { Link } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost } from "../../../api";

import { DownloadFile } from "../../../utils";

const StatsPage = () => {
  const { user } = useAuthContext();

  const [ticketStats, setTicketStats] = useState([]);
  const [notesStats, setNotesStats] = useState(null);
  const [documentsStats, setDocumentsStats] = useState([]);

  const [ticketStatsData, setTicketStatsData] = useState([]);
  const [documentStatsData, setDocumentStatsData] = useState([]);

  useEffect(() => {
    const fetchTicketsStats = async () => {
      const response = await httpGet(process.env.REACT_APP_URL_BASE + `/stats/tickets`);

      if (response.status === 200) { 
        setTicketStats(await response.json());
      }else{
        console.log(response);
        alert("Something went wrong");
      }
    }

    const fetchNotesStats = async () => {
      const response = await httpGet(process.env.REACT_APP_URL_BASE + `/stats/notes`); 

      if (response.status === 200) {
        response.json().then((data) => {
          setNotesStats(parseInt(data[0].note));
        })
      }else{
        console.log(response); 
        alert("Something went wrong");
      }
    }

    const fetchDocumentsStats = async () => {
      const response = await httpGet(process.env.REACT_APP_URL_BASE + `/stats/documents`); 

      if (response.status === 200) {
        setDocumentsStats(await response.json()); 
      }else{
        console.log(response);  
        alert("Something went wrong");
      }
    }

    fetchTicketsStats();
    fetchNotesStats();
    fetchDocumentsStats();
  }, [])

  useEffect(() => {
    const _data = {
      data: [],
      colors: [],
      labels: []
    }
    const status = {
            "open": "info",
            "closed": "secondary",
            "treated": "success",
            "progress": "warning"
          }

    ticketStats.forEach((item) => {
        _data.data.push(item.total);
        _data.colors.push(status[item.status]);
        _data.labels.push(item.status.toUpperCase());
    })

    setTicketStatsData(_data);
    
  }, [ticketStats])

  useEffect(() => {

    const _data = {
      data: [],
      labels: []
    }

    documentsStats.forEach((item) => {
      _data.data.push(item.downloaded);
      _data.labels.push(item.name.toUpperCase());
    })

    setDocumentStatsData(_data);
    
  }, [documentsStats])


  return ( 
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"
                sx={{textAlign: "center"}}
              >
                <MDTypography variant="h3" color="white">
                  Statistics
                </MDTypography>
              </MDBox>
              <MDBox p={3} sx={{
                  display: "flex",
                  justifyContent:"center",
                  alignItems: "center",
                  flexDirection: 'column'}}>

                  <MDBox m={3} sx={{ width: "100%", height: "100%", display: "flex", justifyContent:"space-around" }}>
                    <PieChart
                      icon={{ color: "error", component: "leaderboard" }}
        						  title="Ticket Statuses"
        						  description="Analytics Of Current Tickets Statuses"
        						  chart={{
        						    labels: ticketStatsData.labels,
        						    datasets: {
        						      label: "Number",
        						      backgroundColors: ticketStatsData.colors,
        						      data: ticketStatsData.data,
        						    },
        						  }}
        						/>
                    <VerticalBarChart
                      icon={{ color: "error", component: "leaderboard" }}
                      title="Documents Download"
                      description="Analytics of the top 3 most downloaded documents"
                      chart={{
                        labels: documentStatsData.labels,
                        datasets: [{
                          label: "Total Download",
                          color: "info",
                          data: documentStatsData.data,
                        }],
                      }}
                    />

                  </MDBox>


                  <MDBox sx={{margin: "5em 0", textAlign: "center"}}>
                    <MDBox>
                      <MDTypography variant="h2">
                        Average client satisfaction :
                      </MDTypography>
                      <br />
                      <MDTypography variant="h3" color={notesStats > 2.5 ? "success" : "warning"}>
                        {notesStats * 20 / 5} / 20
                      </MDTypography>
                    </MDBox>
                  </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    </>

  )
}

export default StatsPage